<template lang="pug">
    div(class="_row")
        slot
</template>

<script>
    /**
     * A row in the [grid](#/classes/grid) system. Rows should only contain [ib-col](#/components/layout/ib-col)
     * direct children.
     *
     * Most commonly, this is used as an element rather than a component (which would have higher memory and compute
     * overhead) by using `.ib-row` in your template rather than `ib-row`.
     */
    export default {
        name: 'ib-row'
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    .ib-row,
    ._row {
        display: flex;
        flex: none;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;

        &.grow {
            flex: 1 1 100%;
        }
        &.shrink {
            flex: 0 1 auto;
        }
        &.grow,
        &.shrink {
            overflow-x: hidden;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            --padding-top: 0;
            --padding-right: 0;
            --padding-bottom: 0;
            --padding-left: 0;
        }

        &:focus {
          outline: none;
        }
        &:focus-visible {
          outline: 2px solid @fg-accent;
          outline-offset: -2px;
        }
    }
</style>
